"use client";
import { Box, Wrap, WrapItem } from "@chakra-ui/react";
import Image from "next/image";
import PageLayout from "@/layouts/pageLayout";
import { useHeadingVariant, useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Heading, Text } from "@/elements";
import BgImage from "public/shared/lbBg.png";
import TickImage from "public/shared/check-box.png";

type WhyOnemindProps = {
  title: string;
  list: string[];
};

const OneMindFeatures = (props: WhyOnemindProps) => {
  const HeadingVariant = useHeadingVariant();
  const TextVariant = useTextVariant();
  const { title, list } = props;
  return (
    <Box bgImage={`url(${BgImage.src})`} bgSize="cover" py={12}>
      <PageLayout marginTop={0}>
        <Box maxW="6xl" mx="auto">
          <Heading variant={HeadingVariant} mb={8} textAlign="center">
            {title}
          </Heading>
          <Wrap gap={6} justify="center">
            {list.map((item, index) => (
              <WrapItem key={index} px={4} py={3} bg="white" borderRadius="xl">
                <Image
                  alt={"Point"}
                  src={TickImage}
                  style={{ height: "auto", width: "20px", paddingTop: "4px" }}
                />{" "}
                <Text variant={TextVariant} color="text.100" ml={2}>
                  {item}
                </Text>
              </WrapItem>
            ))}
          </Wrap>
        </Box>
      </PageLayout>
    </Box>
  );
};

export default OneMindFeatures;
